import styled from 'styled-components';
import { Modal as ModalComponent } from 'react-bootstrap';

interface IStatus {
  status: string;
}

export const Container = styled.div`
  min-width: calc(100% - 88px);

  h1 {
    font-size: 26px;
    font-weight: 500;
  }

  hr {
    background: #e1e1e1;
    opacity: 1;
  }

  a {
    :hover {
      color: unset;
    }
  }

  .container-fluid {
    max-width: 1460px;
  }

  .btn-new {
    border-radius: 4px;
    background: #ff6900;
    border: none;
  }

  .bg-white {
    border-radius: 8px;
    ::-webkit-scrollbar {
      background: transparent;
      width: 5px;
      height: 8px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #002f6c;
      border-radius: 4px;
    }
  }

  .bg-balance {
    border-radius: 8px;
    background: linear-gradient(268deg, #ff9e2d 0%, #ff6900 100%);
  }
`;

export const Filter = styled.div`
  h2 {
    color: #000;
    font-family: 'Roboto';
  }
`;

export const TableList = styled.div`
  .btn-icons {
    background: #ff842f;
    border-radius: 20px;
    padding: 6px 8px;
  }
  .min-w {
    min-width: 2410px;
  }
  .table {
    > div:first-child {
      padding: 0px !important;
    }
    div {
      border: none;
    }
  }

  .content {
    ::-webkit-scrollbar {
      background: transparent;
      width: 5px;
      height: 13px;
      border: none;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #002f6c;
      border-radius: 10px;
    }
  }

  .tb-header {
    background-color: #002f6c;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 12px 16px;
  }

  .tb-body {
    padding: 0 0.5rem;
  }

  .tb-header .tb-row button {
    color: #fff;
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 400;
    justify-content: center;

    svg {
      color: #fff !important;
    }
  }

  /* .tb-header .tb-row button:last-child {
    width: 138px !important;
    min-width: 138px !important;
  }

  .tb-body .tb-row div:last-child {
    min-width: 138px !important;
    width: auto !important;
  } */

  .tb-header .tb-row button:not(:first-child) {
    width: 200px;
  }

  .tb-header .tb-row button:first-child {
    svg {
      display: none;
    }
  }

  .tb-header .tb-row {
    button:nth-child(1) {
      width: 180px;
    }
    button:nth-child(2) {
      width: 130px;
    }
    button:nth-child(5) {
      width: 120px;
    }
    button:nth-child(6) {
      width: 80px;
    }
    button:nth-child(7) {
      width: 140px;
    }
    button:nth-child(8) {
      width: 150px;
    }
    button:nth-child(9) {
      width: 250px;
    }
    button:nth-child(10) {
      width: 100px;
    }
    button:nth-child(11) {
      width: 100px;
    }
    button:nth-child(12) {
      width: 110px;
    }
    button:nth-child(13) {
      width: 230px;
    }
    button:nth-child(14) {
      width: 140px;
    }
    button:nth-child(15) {
      width: 150px;
    }
    button:nth-child(16) {
      width: 120px;
    }
    button:nth-child(17) {
      width: 130px;
    }
    button:nth-child(20) {
      width: 250px;
    }
    button:nth-child(25) {
      width: 100px;
    }
    button:nth-child(26) {
      width: 140px;
    }
    button:last-child {
      width: 140px;
    }
  }

  .tb-body .tb-row {
    padding: 0.5rem 0.5rem;
    text-align: center;

    :not(:last-child) {
      border-bottom: 0.5px solid #e1e1e1;
    }

    div:not(:first-child) {
      color: #7e7e7e;
      font-family: 'Roboto';
      font-size: 16px;
      font-weight: 400;
      width: 200px;
      text-wrap: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    div:nth-child(1) {
      width: 180px;
    }
    div:nth-child(2) {
      width: 130px;
    }
    div:nth-child(5) {
      width: 120px;
    }
    div:nth-child(6) {
      width: 80px;
    }
    div:nth-child(7) {
      width: 140px;
    }
    div:nth-child(8) {
      width: 150px;
    }
    div:nth-child(9) {
      width: 250px;
    }
    div:nth-child(10) {
      width: 100px;
    }
    div:nth-child(11) {
      width: 100px;
    }
    div:nth-child(12) {
      width: 110px;
    }
    div:nth-child(13) {
      width: 230px;
    }
    div:nth-child(14) {
      width: 140px;
    }
    div:nth-child(15) {
      width: 150px;
    }
    div:nth-child(16) {
      width: 120px;
    }
    div:nth-child(17) {
      width: 130px;
    }
    div:nth-child(20) {
      width: 250px;
    }
    div:nth-child(25) {
      width: 100px;
    }
    div:nth-child(26) {
      width: 140px;
    }
    div:last-child {
      width: 140px;
    }
  }

  @media screen and (min-width: 992px) {
    /* .number-id:not(:nth-child(5)) {
      min-width: 45px;
      width: auto;
    } */
    .number-id {
      padding: 0px 7px;
    }
  }
`;

export const Modal = styled(ModalComponent)`
  .table-modal > div {
    padding: 0px !important;

    > div {
      padding: 0px;
      border: none;
    }
  }
`;

export const ModalTransferModCat = styled(ModalComponent)`
  backdrop-filter: blur(3px);
  .border {
    border-radius: 8px;
    border: 2px solid #8c8c8c !important;
  }

  .title-mod {
    color: #ff6900;
  }
  .modal-content {
    .btn-login {
      border-radius: 4px;
      background-color: #ff6900;
      color: #fff;
    }
  }

  .btn-cancel {
    border-radius: 4px;
    background-color: #ccc;
    color: #fff;
  }

  .check-mod-cat label {
    margin-left: 0px;
    margin-bottom: 16px;

    > span {
      width: 100%;
    }
  }

  .alinhar-preenchimento {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
  }

  .texto-fixo {
    flex-shrink: 0;
    white-space: nowrap;
  }

  .pontos {
    flex-grow: 1;
    border-bottom: 2px dotted #888;
    margin: 0 8px 4px 8px;
  }
`;

export const ModalTransfer = styled(ModalComponent)`
  backdrop-filter: blur(3px);

  .modal-content {
    .btn-login {
      border-radius: 4px;
      background-color: #ff6900;
      color: #fff;
    }

    .bd-input {
      border: 1px solid #e1e1e1;
      height: 40px;
      border-radius: 4px;

      input {
        width: 100%;
        flex: 1;
        background: transparent;
        border: 0;
        color: #000;
        transition-duration: 0.2s;

        ::placeholder {
          color: #8c8c8c;
        }
      }
      /* svg:not(.check-icon, .rotate-arrow) {
        display: none;
      } */
    }

    .select-tam input {
      font-size: 16px;
    }
  }
  .check span {
    color: #202020;
    font-size: 16px;
    font-weight: 400;
  }

  .copy-btn {
    border-radius: 4px;
    background-color: #ff6900;
    color: #fff;
  }

  .close-btn {
    position: absolute;
    top: 10px;
    right: 12px;
    border: none;
  }

  .bg-information {
    border-radius: 8px;
    background: #f6f6f6;
    padding: 16px;
  }
  .bg-white {
    border-radius: 8px;
  }
`;

export const TableListModal = styled.div`
  .btn-icons {
    background: #ff842f;
    border-radius: 20px;
    padding: 6px 8px;
  }
  .min-w {
    min-width: 2410px;
  }
  .table {
    > div:first-child {
      padding: 0px !important;
    }
    div {
      border: none;
    }
  }

  .content {
    ::-webkit-scrollbar {
      background: transparent;
      width: 5px;
      height: 13px;
      border: none;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #002f6c;
      border-radius: 10px;
    }
  }

  .tb-header {
    background-color: #002f6c;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 12px 16px;
  }

  .tb-body {
    padding: 0 0.5rem;
  }

  .tb-header .tb-row button {
    color: #fff;
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 400;
    justify-content: center;

    svg {
      color: #fff !important;
    }
  }

  /* .tb-header .tb-row button:last-child {
    width: 138px !important;
    min-width: 138px !important;
  }

  .tb-body .tb-row div:last-child {
    min-width: 138px !important;
    width: auto !important;
  } */

  .tb-header .tb-row button:not(:first-child) {
    width: 12%;
  }

  .tb-header {
    width: 100%;
  }

  .tb-header .tb-row {
    width: 100%;
    button:nth-child(1) {
      width: 6%;
    }
    button:nth-child(2) {
      width: 47%;
    }
    button:nth-child(3) {
      width: 47%;
    }
  }

  .tb-body {
    width: 100%;
    > div {
      width: 100%;
    }
  }

  .tb-body .tb-row {
    padding: 0.5rem 0.5rem;
    text-align: center;
    width: 100%;

    :not(:last-child) {
      border-bottom: 0.5px solid #e1e1e1;
    }

    div:not(:first-child) {
      color: #7e7e7e;
      font-family: 'Roboto';
      font-size: 16px;
      font-weight: 400;
      width: 12%;
      text-wrap: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    div:nth-child(1) {
      width: 6%;
    }
    div:nth-child(2) {
      width: 47%;
    }
    div:nth-child(3) {
      width: 47%;
    }
  }

  @media screen and (min-width: 992px) {
    .number-id:not(:nth-child(5)) {
      min-width: 45px;
      width: auto;
    }
    .number-id {
      padding: 0px 7px;
    }
  }
`;

export const Status = styled.p<IStatus>`
  background-color: ${(props) => {
    switch (props.status) {
      case 'Aguardando pagamento':
        return '#dbb100';
      case 'Pago':
        return '#427242';
      case 'Cancelado':
      case 'Expirado':
        return '#bf2216';
      case 'Devolução Total':
      case 'Devolução Parcial':
      case 'DEVOLUÇÃO TOTAL':
      case 'DEVOLUÇÃO PARCIAL':
        return '#8c8c8c';
      default:
        return '#000';
    }
  }};
  padding: 3px;
`;
